module.exports = __webpack_public_path__ + "img/chevron-down-solid.c411f3e0.svg";